// extracted by mini-css-extract-plugin
export var base = "_1k-0";
export var updateBanner = "_1k-1";